import { p as palette } from '../base/color-ec580bc4.js';
import { a as spacingValues, s as spacing } from '../base/spacing-b4d393ed.js';
import { t as typography } from '../base/typography-dd13a6be.js';

const treeViewStyles = {
  indentValue: spacingValues.medium,
  discloseIconColor: typography.color.tertiary,
  discloseIconSize: spacing.mini,
  discloseButtonSize: spacing.medium,
  discloseButtonWrapperSize: spacing.xlarge,
  nodeContentPadding: spacing.micro,
  nodeSeparator: `1px solid ${palette.mercury}`,
  nodeActiveColor: palette.haze
};
var treeViewStyles$1 = treeViewStyles;

export { treeViewStyles$1 as t };
//# sourceMappingURL=treeView-9ec76403.js.map
